import * as React from "react";
import * as ReactDOM from "react-dom";
import Index from "./view/home";
import registerServiceWorker from "../registerServiceWorker";
import "./assets/style/global.scss";
import "./assets/style/style.scss";
import { store } from "public@store/index";
import { Provider } from "mobx-react";
import "@babel/polyfill";

const AppStore = { store };
ReactDOM.render(
  <Provider {...AppStore}>
    <Index />
  </Provider>,
  document.getElementById("root") as HTMLElement
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/pc/index.tsx